import { render, staticRenderFns } from "./sd.vue?vue&type=template&id=fdf537b8&scoped=true"
import script from "./sd.vue?vue&type=script&lang=js"
export * from "./sd.vue?vue&type=script&lang=js"
import style0 from "./sd.vue?vue&type=style&index=0&id=fdf537b8&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf537b8",
  null
  
)

export default component.exports